import { TeamTypes, TeamTypesReadable } from "@/gql/graphql";

export const getReadableRole = (role: string): string => {
  let readableRole = '';

  switch (role) {
    case TeamTypes.Taker:
      readableRole = TeamTypesReadable.OwnerDriver.split('_').join(' ');
      break;
    case TeamTypes.Poster:
      readableRole = TeamTypesReadable.FreightForwarder.split('_').join(' ');
      break;
    case TeamTypes.Both:
      readableRole = TeamTypesReadable.CourierCompany.split('_').join(' ');
      break;
  }

  return readableRole;
};
